<template>
  <div>
    <el-dialog title="Login" :lock-scroll="false" :visible.sync="visible" width="400px">
      <div class="social-auth-ctn">
        <div class="login-btn" @click="socialAuth('github')">
          <icon class="login-icon">github</icon>
          <div class="login-icon-text">Github</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    let self = this
    self.env.ui.showLoginAddCallback(() => { self.visible = true })
  },
  methods: {
    socialAuth(provider) {
      console.log("socialAuth: provider: ", provider)
      this.$auth.authenticate(provider).then(function () {
        // Execute application logic after successful social authentication
        console.log(`auth by ${provider} success`)
      })
    }
  },
}
</script>

<style scoped>
.social-auth-ctn {
  display: flex;
  justify-content: center;
}

.login-btn {
  color: #000;
  padding: 8px;
}
.login-btn:hover {
  color: #444;
}
.login-btn:active {
  color: #888;
}
.login-icon {
  font-size: 80px;
}
.login-icon-text {
  margin-top: 8px;
}
</style>